import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { useEffect, useMemo, useState } from 'react'

export const useSMSRateLimit = () => {
  const rateLimitReset = useStoreSelector((state) => state.app.creditCard.createPhoneRequest['x-ratelimit-reset'] || null)

  const [cache, render] = useState({})
  const secondsLeft = useMemo(() => {
    const resetTimestamp = +(rateLimitReset || 0) * 1000
    if (!resetTimestamp) {
      return null
    }

    const seconds = Math.round((resetTimestamp - +new Date()) / 1000)
    if (seconds < 0) {
      return null
    }

    return seconds
  }, [cache, rateLimitReset])

  useEffect(() => {
    if (!secondsLeft || secondsLeft < 0) {
      return
    }

    let tmr = 0
    const handler = () => {
      render({})
      tmr = window.setTimeout(handler, 1000)
    }
    handler()

    return () => {
      window.clearTimeout(tmr)
    }
  }, [secondsLeft])

  return secondsLeft
}
